import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import theme from '../../../theme';

/**
 * Universal Breadcrumbs component
 * @param {Object[]} links - Array of objects containing path and label for each breadcrumb
 * @param {string} links[].path - The URL path for the breadcrumb
 * @param {string} links[].label - The display text for the breadcrumb
 */
const Breadcrumbs = ({ links }) => {
    return (
        <MuiBreadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{
                mb: theme.spacing.breadcrumbBottom,
                '& .MuiBreadcrumbs-ol': {
                    flexWrap: 'nowrap',
                    overflow: 'hidden',
                },
                '& .MuiBreadcrumbs-li': {
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: 0,
                },
                '& .MuiBreadcrumbs-separator': {
                    margin: { xs: '0 4px', sm: '0 8px' },
                },
            }}
        >
            {links.map((link, index) => {
                const isLast = index === links.length - 1;

                return isLast ? (
                    <Typography
                        key={link.path}
                        color="text.primary"
                        sx={{
                            fontWeight: theme.typography.fontWeights.semiBold,
                            fontSize: { xs: '0.875rem', sm: theme.typography.breadcrumb.fontSize },
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minHeight: '44px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {link.label}
                    </Typography>
                ) : (
                    <Link
                        key={link.path}
                        component={RouterLink}
                        to={link.path}
                        color="text.secondary"
                        sx={{
                            textDecoration: 'none',
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                            fontSize: { xs: '0.875rem', sm: theme.typography.breadcrumb.fontSize },
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            minHeight: '44px',
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: 0,
                        }}
                    >
                        {link.label}
                    </Link>
                );
            })}
        </MuiBreadcrumbs>
    );
};

export default Breadcrumbs;
